import React, { useState, useEffect, useContext } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import { IconButton, Select, MenuItem, TextField } from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  criarAjusteManualVerba,
  obterVerbasAjustadas,
  obterVerbasAjustadasPorCampoDeBusca,
} from "../../services/api-esocial.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  CurrencyExchange,
  Pending,
} from "@mui/icons-material";
import { simplifyString } from "../../utils/simplify_string";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const AjustesVerbas = () => {
  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [verbasData, setVerbasData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [debounceValue, setDebounceValue] = useState("");
  const [columnSearch, setColumnSearch] = useState("codigoRubrica");

  const colunaPesquisa = [
    { value: "codigoRubrica", label: "Código da Rubrica" },
    { value: "descricaoRubrica", label: "Descrição da Rubrica" },
  ];

  const handleChangeColumnSearch = (event) => {
    setColumnSearch(event.target.value);
  };

  const handleAddComposicaoProjeto = async (row) => {
    await handleComposicaoProjeto(row, true);
  };

  const handleRemoveComposicaoProjeto = async (row) => {
    await handleComposicaoProjeto(row, false);
  };

  const handleAddVerbaFerias = async (row) => {    
    setVerbasData(prevVerbasData =>
      prevVerbasData.map(verba =>
        verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade
          ? { ...verba, verbaFerias: undefined }
          : verba
      )
    );

    let idIncidencia;
    switch (row.incidencia) {
      case "Sim":
        idIncidencia = 1;
        break;
      case "Não":
        idIncidencia = 2;
        break;
      case "Nunca":
        idIncidencia = 3;
        break;
      default:
        idIncidencia = 2;
        break;
    }

    const data = {
      ajusteVerba: {
        idTabelaRubrica: row.idTabelaRubrica,
        codRubrica: row.codigoRubrica,
        tipoRubrica: row.tipoRubrica === "Provento" ? "P" : "D",
        descricaoRubrica: row.descricaoRubrica,
        inicioValidade: row.inicioValidade,
        tipoIncidenciaVerba: idIncidencia,
        composicao: row.composicaoProjeto,
        verbaFerias: true
      }
    };

    try {
      const response = await criarAjusteManualVerba(idEmpresa, data);
      if (response.sucesso) {        
        setVerbasData(prevVerbasData =>
          prevVerbasData.map(verba =>
            verba.idTabelaRubrica === row.idTabelaRubrica &&
              verba.codigoRubrica === row.codigoRubrica &&
              verba.inicioValidade === row.inicioValidade
              ? { ...verba, verbaFerias: true }
              : verba
          )
        );
      }
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      setVerbasData(prevVerbasData =>
        prevVerbasData.map(verba =>
          verba.idTabelaRubrica === row.idTabelaRubrica &&
            verba.codigoRubrica === row.codigoRubrica &&
            verba.inicioValidade === row.inicioValidade
            ? { ...verba, verbaFerias: row.verbaFerias }
            : verba
        )
      );
    }
  };

  const handleRemoveVerbaFerias = async (row) => {    
    setVerbasData(prevVerbasData =>
      prevVerbasData.map(verba =>
        verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade
          ? { ...verba, verbaFerias: undefined }
          : verba
      )
    );

    let idIncidencia;
    switch (row.incidencia) {
      case "Sim":
        idIncidencia = 1;
        break;
      case "Não":
        idIncidencia = 2;
        break;
      case "Nunca":
        idIncidencia = 3;
        break;
      default:
        idIncidencia = 2;
        break;
    }

    const data = {
      ajusteVerba: {
        idTabelaRubrica: row.idTabelaRubrica,
        codRubrica: row.codigoRubrica,
        tipoRubrica: row.tipoRubrica === "Provento" ? "P" : "D",
        descricaoRubrica: row.descricaoRubrica,
        inicioValidade: row.inicioValidade,
        tipoIncidenciaVerba: idIncidencia,
        composicao: row.composicaoProjeto,
        verbaFerias: false
      }
    };

    try {
      const response = await criarAjusteManualVerba(idEmpresa, data);
      if (response.sucesso) {       
        setVerbasData(prevVerbasData =>
          prevVerbasData.map(verba =>
            verba.idTabelaRubrica === row.idTabelaRubrica &&
              verba.codigoRubrica === row.codigoRubrica &&
              verba.inicioValidade === row.inicioValidade
              ? { ...verba, verbaFerias: false }
              : verba
          )
        );
      }
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      setVerbasData(prevVerbasData =>
        prevVerbasData.map(verba =>
          verba.idTabelaRubrica === row.idTabelaRubrica &&
            verba.codigoRubrica === row.codigoRubrica &&
            verba.inicioValidade === row.inicioValidade
            ? { ...verba, verbaFerias: row.verbaFerias }
            : verba
        )
      );
    }
  };

  const handleChangeIncidenciaVerba = async (row, idIncidencia) => {
    let valorComposicaoProjeto;
    let valorVerbaFerias;
    setVerbasData(
      verbasData.map((verba) => {
        if (
          verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade
        ) {
          valorComposicaoProjeto = verba.composicaoProjeto;
          valorVerbaFerias = verba.verbaFerias;
          return {
            ...verba,
            incidencia_selectValue: undefined,
            composicaoProjeto: undefined,
            verbaFerias: undefined
          };
        } else {
          return verba;
        }
      })
    );
    const data = {
      ajusteVerba: {
        idTabelaRubrica: row.idTabelaRubrica,
        codRubrica: row.codigoRubrica,
        tipoRubrica:
          row.tipoRubrica === "Provento"
            ? "P"
            : row.tipoRubrica === "Desconto"
            ? "D"
            : "",
        descricaoRubrica: row.descricaoRubrica,
        inicioValidade: row.inicioValidade,
        tipoIncidenciaVerba: idIncidencia,
        composicao: row.composicaoProjeto,
        verbaFerias: valorVerbaFerias
      },
    };
    const response = await criarAjusteManualVerba(idEmpresa, data);
    if (!!response.sucesso) {
      setVerbasData(
        verbasData.map((verba) =>
          verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade
            ? {
              ...verba,
              incidencia_selectValue: idIncidencia,
              incidencia: (() => {
                switch (idIncidencia) {
                  case 1:
                    return "Sim";
                  case 2:
                    return "Não";
                  case 3:
                    return "Nunca";
                  default:
                    return "";
                }
              })(),
              composicaoProjeto: valorComposicaoProjeto,
              verbaFerias: valorVerbaFerias
            }
            : verba
        )
      );
    }
  };

  const handleComposicaoProjeto = async (row, composicao) => {
    let valorIncidencia_selectValue;
    let valorVerbaFerias;

    setVerbasData(
      verbasData.map((verba) => {
        if (
          verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade &&
          verba.finalValidade === row.finalValidade
        ) {
          valorIncidencia_selectValue = verba.incidencia_selectValue;
          valorVerbaFerias = verba.verbaFerias;
          return {
            ...verba,
            composicaoProjeto: undefined,
            incidencia_selectValue: undefined,
          };
        }
        return verba;
      })
    );

    let idIncidencia;
    switch (row.incidencia) {
      case "Sim":
        idIncidencia = 1;
        break;
      case "Não":
        idIncidencia = 2;
        break;
      case "Nunca":
        idIncidencia = 3;
        break;
      default:
        idIncidencia = 2;
        break;
    }
    
    const data = {
      ajusteVerba: {
        idTabelaRubrica: row.idTabelaRubrica,
        codRubrica: row.codigoRubrica,
        tipoRubrica:
          row.tipoRubrica === "Provento"
            ? "P"
            : row.tipoRubrica === "Desconto"
            ? "D"
            : "",
        descricaoRubrica: row.descricaoRubrica,
        inicioValidade: row.inicioValidade,
        tipoIncidenciaVerba: idIncidencia,
        composicao: composicao,
        verbaFerias: valorVerbaFerias      
      },
    };
    const response = await criarAjusteManualVerba(idEmpresa, data);
    if (!!response.sucesso) {
      setVerbasData(
        verbasData.map((verba) =>
          verba.idTabelaRubrica === row.idTabelaRubrica &&
          verba.codigoRubrica === row.codigoRubrica &&
          verba.inicioValidade === row.inicioValidade &&
          verba.finalValidade === row.finalValidade
            ? {
                ...verba,
                composicaoProjeto: composicao,
                incidencia_selectValue: valorIncidencia_selectValue,
                verbaFerias: valorVerbaFerias
              }
            : verba
        )
      );
    }
  };

  const columns = [
    {
      id: "inicioValidade",
      label: "Inicio da\nValidade",
      field: "inicioValidade_cellVal",
    },
    {
      id: "fimValidade",
      label: "Fim (Calculado)\nda Validade",
      field: "fimValidade_cellVal",
    },
    {
      id: "codigoRubrica",
      label: "Código\nda Rubrica",
      field: "codigoRubrica_cellVal",
    },
    {
      id: "descricaoRubrica",
      label: "Descrição\nda Rubrica",
      field: "descricaoRubrica",
    },
    { id: "tipoRubrica", label: "Tipo da\nRubrica", field: "tipoRubrica" },
    {
      id: "incidencia",
      label: "Incidência\nda Rubrica",
      render: (row) => (
        <div>
          {!!row.incidencia_selectValue ? (
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              small
              value={row.incidencia_selectValue}
              onChange={(event) =>
                handleChangeIncidenciaVerba(row, event.target.value)
              }
              variant={"standard"}
              sx={{ width: "80px" }}
            >
              <MenuItem value={1}>Sim</MenuItem>
              <MenuItem value={2}>Não</MenuItem>
              <MenuItem value={3}>Nunca</MenuItem>
            </Select>
          ) : (
            <>{"Carregando..."}</>
          )}
        </div>
      ),
    },
    {
      id: "composicaoProjeto",
      label: "Composição\ndo Projeto",
      render: (row) => (
        <div>
          {!!row.composicaoProjeto ? (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => handleRemoveComposicaoProjeto(row)}
              >
                <CheckBox />
              </IconButton>
              {"Sim"}
            </>
          ) : typeof row.composicaoProjeto === "undefined" ? (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => {
                  handleAddComposicaoProjeto(row);
                }}
              >
                <Pending />
              </IconButton>
              {"Carregando..."}
            </>
          ) : (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => {
                  handleAddComposicaoProjeto(row);
                }}
              >
                <CheckBoxOutlineBlank />
              </IconButton>
              {"Não"}
            </>
          )}
        </div>
      ),
    },
    {
      id: "verbaFerias",
      label: "Verbas de Afastamento",
      render: (row) => (
        <div>
          {row.verbaFerias === true ? (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => handleRemoveVerbaFerias(row)}
              >
                <CheckBox />
              </IconButton>
              {"Sim"}
            </>
          ) : row.verbaFerias === undefined ? (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => {
                  handleAddVerbaFerias(row);
                }}
              >
                <Pending />
              </IconButton>
              {"Carregando..."}
            </>
          ) : (
            <>
              <IconButton
                aria-label="edit"
                className={styles.iconeTabela}
                onClick={() => {
                  handleAddVerbaFerias(row);
                }}
              >
                <CheckBoxOutlineBlank />
              </IconButton>
              {"Não"}
            </>
          )}
        </div>
      ),
    },
  ];

  const getVerbas = async (idEmpresa) => {
    try {
      const response = await obterVerbasAjustadas(idEmpresa);
      const verbas = response.verbas;
      verbas.forEach((verba) => {
        if (verba.descricaoRecenteRubrica === null)
          verba.descricaoRecenteRubrica = "";
        if (verba.descricaoManualRubrica === null)
          verba.descricaoManualRubrica = "";
        if (verba.codigoRubrica)
          verba.codigoRubrica_cellVal = simplifyString(verba.codigoRubrica);
        if (verba.inicioValidade)
          verba.inicioValidade_cellVal =
            verba.inicioValidade.split("-")[1] +
            "/" +
            verba.inicioValidade.split("-")[0];
        if (verba.fimValidade)
          verba.fimValidade_cellVal =
            verba.fimValidade.split("-")[1] +
            "/" +
            verba.fimValidade.split("-")[0];
        if (verba.incidencia) {
          if (verba.incidencia === "Sim") {
            verba.incidencia_selectValue = 1;
          } else if (verba.incidencia === "Não") {
            verba.incidencia_selectValue = 2;
          } else if (verba.incidencia === "Nunca") {
            verba.incidencia_selectValue = 3;
          } else verba.incidencia_selectValue = null;
        }       
        if (verba.verbaFerias === undefined) {
          verba.verbaFerias = false;
        }
      });
      setVerbasData(verbas);
      setFilteredData(verbas);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false)
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleFilter = (valueSearch) => {
    setLoading(true);
    if (valueSearch) {
      const searchTerm = valueSearch.toLowerCase();

      const newFilteredData = verbasData.filter((item) => {
        switch (columnSearch) {
          case 'codigoRubrica':
            const codigoRubricaMatch =
              String(item.codigoRubrica).toLowerCase() === searchTerm;
              return codigoRubricaMatch;
          case 'descricaoRubrica':
            const descricaoRubricaMatch = String(item.descricaoRubrica)
              .toLowerCase()
              .includes(searchTerm);
              return descricaoRubricaMatch;
          default:
            break;
        }
      });

      setFilteredData(newFilteredData);
    } else {
      setFilteredData(verbasData);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleFilter(debounceValue);
  }, [verbasData, columnSearch]);

  const handleDebouncerChange = async (event) => {
    setDebounceValue(event.target.value);
    handleFilter(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (idGrupoEconomico !== null && idEmpresa !== null) {
        setLoading(true);
        await getVerbas(idEmpresa);
        setLoading(false);
      } else {
        setLoading(true);
        setVerbasData([]);
        setLoading(false);
      }
    };

    fetchData();
  }, [idEmpresa]);

  const handleGrupoECnpjChange = async (ids) => {
    setIdGrupoEconomico(ids.GE);
    setIdEmpresa(ids.CNPJ);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<CurrencyExchange fontSize="30px" />}
        headerTitle={"Ajuste de Verbas"}
        handleDebounceChange={handleDebouncerChange}
        AutoCompleteGrupoECnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
        disableModalButton
      />
      <div className={styles.selectContainer}>
        <ManageSearchIcon className={styles.iconSearch}/>
        <TextField
          id="standard-select"
          select
          label="Coluna de Pesquisa"
          variant="standard"
          defaultValue="codigoRubrica"
          onChange={handleChangeColumnSearch}
          value={columnSearch}
        >
          {colunaPesquisa.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <TabelaDinamica
        data={filteredData}
        columns={columns}
        loading={loading}
        orderColumn={"idImposto"}
        disableEdit
        disableDelete
      />

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default AjustesVerbas;